export default {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  VIEW_ALL: 'VIEW_ALL',
  DELETE: 'DELETE',
  APPROVE: 'APPROVE',
  PUBLISH: 'PUBLISH',
}
